import styled from 'styled-components';
import { Link as RouterLink } from 'react-router-dom';
import { Colors } from '../utils/style/colors';
import { Text } from '../utils/style/texts';

const css = `
	color: ${Colors.blue};
	font-weight: bold;
	text-decoration: none;
	cursor: pointer;
	&:hover {
		text-decoration: underline;
	}
`;

export const Link = styled(RouterLink)`${css}`;
export const ClickLink = styled(Text)`${css}`;